<div class="grid grid-cols-1 gap-8 md:grid-cols-4">
    @for (asset of assets; track asset?.sys?.id || index; let index = $index) {
        <div [ngClass]="styles[index][0]" class="aspect-h-1 aspect-w-1">
            <app-trips-itinerary-gallery-item
                [asset]="asset"
                [orientation]="styles[index][1]">
            </app-trips-itinerary-gallery-item>
        </div>
    }
</div>
